// import Cookies from "js-cookie";
// import { Message } from "element-ui";
const TokenKey = "KK-PlatForm-TOKEN";

// export function getToken() {
//   return localStorage.getItem(TokenKey);
// }

// export function setToken(token) {
//   return localStorage.setItem(TokenKey, token);
// }

// export function removeToken() {
//   return localStorage.removeItem(TokenKey);
// }

// 获取当前网页的协议+域名
export function getBaseUrl() {
  let baseURL = "";
  if (!window.location.origin) {
    // 兼容IE，IE11版本下location.origin为undefined
    window.location.origin = `${window.location.protocol}//${
      window.location.hostname +
      (window.location.port ? ":" + window.location.port : "")
    }/`;
  } else {
    baseURL = window.location.origin + "/";
  }

  return baseURL;
}
// 获取WS路径
export function getWsUrl() {
  let type = 3; // 0本地 1开发 2测试 3正式

  return type === 0
    ? "ws://192.168.3.99:8802/user/websocket/"
    : type === 1
    ? "ws://192.168.3.99:8802/user/websocket/"
    : type === 2
    ? "ws://192.168.3.112:8802/user/websocket/"
    : type === 3
    ? "ws://dev.ikukan.com/user/websocket/"
    : "";
}

// 上传图片统一校验方法，参数分别为文件、限制格式（Array）、限制图片大小（MB为单位）
export function imageLoadCheck(file, format, size) {
  return new Promise((resolve, reject) => {
    const type = format.includes(file.type);
    if (!type) {
      // Message({
      //   type: "error",
      //   message: "请上传符合格式要求的图片",
      // });
    }

    const imageSize = file.size / 1024 / 1024 <= size;
    if (type && !imageSize) {
      // Message({
      //   type: "error",
      //   message: "请上传符合大小要求的图片",
      // });
    }

    type && imageSize ? resolve(true) : reject(false);
  });
}
// 解析文件流并转为文件
export function download(fileName, data) {
  let blob = new Blob([data]);
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    let downloadElement = document.createElement("a");
    let href = window.URL.createObjectURL(blob); // 创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName; // 下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); // 点击下载
    document.body.removeChild(downloadElement); // 下载完成移除元素
    window.URL.revokeObjectURL(href); // 释放掉 blob 对象
  }
}
